// 用户说/转转口碑
export default {
  routes: [
    {
      path: '/user-evaluation',
      name: 'userEvaluation',
      meta: {
        title: '用户说',
        pageId: 'W3194'
      },
      component: () =>
        import(/* webpackChunkName: "userEvaluation" */ '../views/userEvaluation/index.vue')
    }
  ]
}
